// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Hospital Settings response body.
 * @see #/components/schemas/HospitalSettings - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface HospitalSettings {
    /**
     * Hospital ID
     *
     */
    hospital_id: string;
    /**
     * Hospital Name
     *
     */
    name?: string | null;
    /**
     * Json field to store all terminal configuration
     *
     */
    config?: any | null;
    /**
     * UTC reset time for Balance calculation
     * @dataFormat time
     */
    balance_calculation_reset_time?: string;
    /**
     * To calculate whether a prescription is overdue or not. Unit is minutes.
     *
     */
    overdue_time?: number;
    /**
     * Hospital address
     *
     */
    address?: string | null;
    /**
     * Allow manual creation of allergies.
     *
     */
    enable_manual_allergy_creation?: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for HospitalSettings
 */
export namespace HospitalSettings {
    /**
     * HospitalSettings Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Hospital ID
         * @type string (`dataFormat` is missing)
         */
        hospitalId: string;
        /**
         * Hospital Name
         * @type string (`dataFormat` is missing)
         */
        name?: string | null;
        /**
         * Json field to store all terminal configuration
         * @type any (`dataFormat` is missing)
         */
        config?: any | null;
        /**
         * UTC reset time for Balance calculation
         * @dataFormat time
         */
        balanceCalculationResetTime?: string;
        /**
         * To calculate whether a prescription is overdue or not. Unit is minutes.
         * @type number (`dataFormat` is missing)
         */
        overdueTime?: number;
        /**
         * Hospital address
         * @type string (`dataFormat` is missing)
         */
        address?: string | null;
        /**
         * Allow manual creation of allergies.
         * @type boolean (`dataFormat` is missing)
         */
        enableManualAllergyCreation?: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * HospitalSettings DTO
     * Transforms HospitalSettings model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend HospitalSettings model */
        static toModel(obj: HospitalSettings): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend HospitalSettings model */
        static toApi(obj: Model): HospitalSettings {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as HospitalSettings;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
